// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"4ce53e2b","377":"2a5b0bf2","417":"6b129c55","467":"440c611b","626":"e5e40771","870":"ea375a96"}[chunkId] + ".js";
};